import styled from 'styled-components'

export const MainContainer = styled.ul`
  padding: 0px;
`
